import { useQuery } from '@tanstack/react-query';
import { workflowApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useWorkflowByOffice(
  officeId: number | null | undefined,
  resourceId: string,
) {
  return useQuery({
    queryKey: queryKeys.workflows.byOffice(officeId ?? -1, resourceId),
    queryFn: ({ signal }) =>
      workflowApiClient.getWorkflowByOffice(
        officeId!,
        resourceId,
        toCancelToken(signal),
      ),
    enabled: officeId != null && officeId > 0,
    staleTime: 60_000,
    meta: { errorContext: 'office workflow' },
  });
}

export function useWorkflowOptionsByOffice(
  officeId: number | null | undefined,
  resourceId: string,
) {
  return useQuery({
    queryKey: queryKeys.workflows.optionsByOffice(officeId ?? -1, resourceId),
    queryFn: ({ signal }) =>
      workflowApiClient.getWorkflowOptionsByOffice(
        officeId!,
        resourceId,
        toCancelToken(signal),
      ),
    enabled: officeId != null && officeId > 0,
    staleTime: 60_000,
    meta: { errorContext: 'office workflow options' },
  });
}
